import React, { useState } from 'react';
import { pingApi } from './PingApi';
import { Button, Box, Typography, Paper, CircularProgress } from '@mui/material';

/**
 * Component to test the API ping functionality
 */
const TestPing: React.FC = () => {
  const [response, setResponse] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handlePing = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await pingApi();
      setResponse(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Equal-IQ API Ping Test
      </Typography>
      
      <Button 
        variant="contained" 
        onClick={handlePing} 
        disabled={loading}
        sx={{ mb: 3 }}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Ping API'}
      </Button>
      
      {response && (
        <Paper 
          elevation={3} 
          sx={{ p: 2, mb: 2, bgcolor: 'success.light' }}
        >
          <Typography variant="h6" gutterBottom>
            Success: Yes
          </Typography>
          <Typography variant="body1" gutterBottom>
            Message: {response.message || 'API ping successful'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Timestamp: {new Date().toISOString()}
          </Typography>
        </Paper>
      )}
      
      {error && (
        <Paper elevation={3} sx={{ p: 2, bgcolor: 'error.light' }}>
          <Typography color="error">
            Error: {error}
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default TestPing;